import { useQuery } from '@tanstack/react-query';
import { ModuleHeader } from '@/components/ui/module-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { api } from '@/lib/api';

export default function SuperMarketingPage() {
  const q = useQuery({
    queryKey: ['super-marketing'],
    queryFn: async () => {
      const r = await api('/api/v1/super/marketing-stats');
      if (r.status !== 200) throw new Error('marketing-stats');
      return r.data;
    },
  });
  const d = q.data;

  return (
    <div className="space-y-6 motion-enter">
      <ModuleHeader
        title="Marketing"
        description="Founding funnel and tenant acquisition signals from the API."
        icon="Megaphone"
        metrics={[
          { label: 'Founding', value: d?.foundingCount ?? '—' },
          { label: 'Seats left', value: d?.seatsLeft ?? '—' },
          { label: 'Trialing', value: d?.trialing ?? '—' },
          { label: 'Signups 7d', value: d?.signups7d ?? '—' },
        ]}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Founding program</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Claimed</span>
              <span className="font-mono data-text">
                {d?.foundingCount ?? '—'} / {d?.foundingCap ?? 100}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Founding signups (audit)</span>
              <span className="font-mono data-text">{d?.foundingSignups ?? '—'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Past due</span>
              <span className="font-mono data-text">{d?.pastDue ?? '—'}</span>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Tenant totals</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Companies</span>
              <span className="font-mono data-text">{d?.companiesTotal ?? '—'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Users</span>
              <span className="font-mono data-text">{d?.usersTotal ?? '—'}</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
